import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsCard from "../components/NewsCard";
import "./Home.css";

function Home() {
  const news = [
    { id: 1, title: "Breaking News 1", desc: "Short description..." },
    { id: 2, title: "Breaking News 2", desc: "Short description..." },
    { id: 3, title: "Breaking News 3", desc: "Short description..." },
  ];

  return (
    <>
      <Header />

      <div className="container">
        <h2>Latest News</h2>

        <div className="news-grid">
          {news.map((item) => (
            <NewsCard key={item.id} news={item} />
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home;